import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader, Tab, TabList } from "@similarweb/ui-components";

import { MetricContainer } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import {
    FlexColumn,
    FlexRow,
    FlexRowFlexEnd,
    RightFlexRow,
} from "pro-features/styled components/StyledFlex/src/StyledFlex";
import type { PropsWithChildren } from "react";

export const MonitorKeywordsGraphWrapper = styled.div`
    width: 100%;
    min-width: 0;
`;
export const TabsContainer = styled(FlexRow)`
    .react-tabs {
        flex: 1;
        min-width: 0;
    }
`;

export const GraphHeaderActions = styled(RightFlexRow)`
    margin-right: 24px;
`;

export const StyledTab = styled(Tab)`
    text-transform: none !important;
`;

export const StyledTabList = styled(TabList)`
    height: 48px;
    background: ${colorsPalettes.carbon[0]};
    border-radius: 6px 6px 0 0;
    > :not(:last-child) {
        flex-grow: 1;
        min-width: 0;
    }
`;

export const MetricContainerStyled = styled(MetricContainer)`
    box-sizing: border-box;
    margin-bottom: 24px;
    width: 100%;
    height: 300px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
`;

export const Footer = styled(FlexRowFlexEnd)`
    height: 52px;
    align-items: center;
    padding-right: 24px;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    background-color: ${colorsPalettes.carbon[0]};
    margin-bottom: 24px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
`;

const ShareOfVoiceContainer = styled(MetricContainer)`
    box-sizing: border-box;
    width: 100%;
    height: 317px;
    border-radius: 0;
    padding: 24px 8px 0 24px;
    @media (max-width: 1300px) {
        padding: 24px 0 0 16px;
    }
`;

const ContentContainer = styled(FlexColumn)`
    height: 100%;
    justify-content: space-between;
`;

export const ShareOfVoiceWrapper = ({ children }: PropsWithChildren) => {
    return (
        <ShareOfVoiceContainer>
            <ContentContainer>{children}</ContentContainer>
        </ShareOfVoiceContainer>
    );
};

export const ShareOfVoiceLoader = () => (
    <PixelPlaceholderLoader
        height="260px"
        width="99.4%"
    />
);
